import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { useSelector } from 'react-redux';
import Box from 'fe-design-base/atoms/Box';
import AlertText from 'fe-design-base/molecules/AlertText';
import Button from 'fe-design-base/molecules/Button/Button';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { getIssueMessage } from 'features/timesheets/TimesheetsPage/dailyReview/DailyReviewView/TableRow/util';
import { getEditMode } from 'features/timesheets/TimesheetsPage/TimecardModal/selectors';
import { EVENT_CATEGORIES, PRODUCT_AREAS } from 'features/timesheets/tracking';

import PopoverMultiStep from 'components/PopoverMultiStep';

import { cxHelpers } from 'util/className';
import { toI18n } from 'util/i18n';
import { useExtendUx } from 'util/uxEvents';

const { cx, cxEl } = cxHelpers('Issue');

const Issue = ({
  issue,
  options,
  title,
  titleIcon,
  onClick,
  onClickTitle,
  onDismissClick,
  body,
}) => {
  const extendUx = useExtendUx();
  extendUx({
    productArea: PRODUCT_AREAS.TIMESHEETS,
    eventCategory: EVENT_CATEGORIES.TIMECARD_DETAILS,
  });

  const isEditMode = useSelector(getEditMode);

  const button = (
    <Button
      variant="tertiary"
      size="small"
      className={cxEl('cta')}
      onClick={onClick}
      uxElement="issue_cta"
    >
      {issue.get('cta')}
    </Button>
  );

  const issueMessage =
    issue.get('type') === 'late_clock_out'
      ? getIssueMessage(issue)
      : issue.get('content');

  return (
    <Box row className={cx()}>
      <Box vcenter>
        <AlertText
          variant={issue.get('variant') || 'error'}
          message={issueMessage}
        />
      </Box>
      {issue.get('cta') && !isEditMode && (
        <Box ml={8}>
          {options ? (
            <PopoverMultiStep
              title={
                isEmpty(title)
                  ? toI18n(
                      `timecard_modal_v3.issues.${issue.get('type')}.title`
                    )
                  : title
              }
              onClickTitle={onClickTitle}
              options={options}
              titleIcon={titleIcon}
              body={body}
            >
              {button}
            </PopoverMultiStep>
          ) : (
            button
          )}
        </Box>
      )}
      {issue.get('dismiss') && issue.get('content') && !isEditMode && (
        <Box ml={8}>
          <Button
            variant="tertiary"
            size="small"
            className={cxEl('dismiss')}
            onClick={onDismissClick}
            uxElement="issue_dismiss"
          >
            {issue.get('dismiss')}
          </Button>
        </Box>
      )}
    </Box>
  );
};

Issue.propTypes = {
  issue: ImmutablePropTypes.map.isRequired,
  option: PropTypes.array,
  title: PropTypes.string,
  titleIcon: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  onClick: PropTypes.func,
  onClickTitle: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onDismissClick: PropTypes.func,
  body: PropTypes.node,
};

export default Issue;
